import type { SelectedTreeObject } from '@core/core/types'
import type { ProjectElementInfo } from 'common/types'

export function findTreeNode(
  tree: ProjectElementInfo[],
  activeEntity: SelectedTreeObject,
): ProjectElementInfo | undefined {
  const found = tree.find(
    node =>
      node.name === activeEntity.entityName &&
      node.projectEntityUid === activeEntity.entityId &&
      activeEntity.entityId,
  )

  if (found) return found

  return tree.reduce<ProjectElementInfo | undefined>((prev, node) => {
    const innerFound = findTreeNode(node.children, activeEntity)
    if (innerFound) return innerFound
    return prev
  }, undefined)
}
